import axios from 'axios';

const state = {
    Appeal: {
        categories: [],
        appeal_tags: [],
    },
    Blog: {
        categories: [],
        subjects: [],
    },
    Job: {
        categories: [],
        job_types: [],
    },
    Story: {
        categories: [],
        subjects: [],
    },
    Team: {
        categories: [],
        positions: []
    },
    Event: {
        categories: [],
        event_categories: [],
        dates: []
    },
    CentenaryStory: {
        themes: [],
        decades: []
    },

    fetching_categories: false,
    fetching_subjects: false,
    fetching_positions: false,
    fetching_jobs: false,
    fetching_appeals: false,
    fetching_team: false,
    fetching_event_categories: false,
    fetching_dates: false,
    fetching_themes: false,
    fetching_decades: false
};

const getters = {
    filters: (state) => (form) => state[form],
    categories: (state) => (form) => state[form].categories,
    appeals: (state) => (form) => state[form].appeal_tags,
    jobs: (state) => (form) => state[form].job_types,
    subjects: (state) => (form) => state[form].subjects,
    positions: (state) => (form) => state[form].positions,
    event_categories: (state) => (form) => state[form].event_categories,
    dates: (state) => (form) => state[form].dates,
    themes: (state) => (form) => state[form].themes,
    decades: (state) => (form) => state[form].decades,

    fetchingCategories: () => state.fetching_categories,
    fetchingAppeals: () => state.fetching_appeals,
    fetchingJobs: () => state.fetching_jobs,
    fetchingSubjects: () => state.fetching_subjects,
    fetchingPositions: () => state.fetching_positions,
    fetchingEventCategories: () => state.fetching_event_categories,
    fetchingDates: () => state.fetching_dates,
    fetchingThemes: () => state.fetching_themes,
    fetchingDecades: () => state.fetching_decades,

    loading: (state, getters) => (getters.fetchingCategories || getters.fetchingSubjects || getters.fetchingJobs || getters.fetchingAppeals || getters.fetchingPositions || getters.fetchingEventCategories || getters.fetchingDates || getters.fetchingThemes || getters.fetchingDecades),
};

const actions = {
    getFilters({getters, dispatch}, postType) {
        let filters = getters.filters(postType);
        for (let filter in filters) {
            dispatch(filter, postType);
        }
    },

    appeal_tags({commit}, postType) {
        commit('FETCHING_APPEALS', true);
        return new Promise((resolve, reject) => {
            axios
                .get(`/api/taxonomies/appeal_tags`)
                .then(({data}) => {
                    commit('SET_APPEALS', {data, postType});
                    commit('FETCHING_APPEALS', false);
                    return resolve();
                })
                .catch((error) => {
                    commit('FETCHING_APPEALS', false);
                    return reject();
                });
        });
    },

    categories({commit}, postType) {
        commit('FETCHING_CATEGORIES', true);
        return new Promise((resolve, reject) => {
            axios
                .get(`/api/taxonomies/master_categories`)
                .then(({data}) => {
                    commit('SET_CATEGORIES', {data, postType});
                    commit('FETCHING_CATEGORIES', false);
                    return resolve();
                })
                .catch((error) => {
                    commit('FETCHING_CATEGORIES', false);
                    return reject();
                });
        });
    },

    job_types({commit}, postType) {
        commit('FETCHING_JOBS', true);
        return new Promise((resolve, reject) => {
            axios
                .get(`/api/taxonomies/job_types`)
                .then(({data}) => {
                    commit('SET_JOBS', {data, postType});
                    commit('FETCHING_JOBS', false);
                    return resolve();
                })
                .catch((error) => {
                    commit('FETCHING_JOBS', false);
                    return reject();
                });
        });
    },

    subjects({commit}, postType) {
        commit('FETCHING_SUBJECTS', true);
        return new Promise((resolve, reject) => {
            axios
                .get(`/api/taxonomies/subjects`)
                .then(({data}) => {
                    commit('SET_SUBJECTS', {data, postType});
                    commit('FETCHING_SUBJECTS', false);
                    return resolve();
                })
                .catch((error) => {
                    commit('FETCHING_SUBJECTS', false);
                    return reject();
                });
        });
    },

    themes({commit}, postType) {
        commit('FETCHING_THEMES', true);
        return new Promise((resolve, reject) => {
            axios
                .get(`/api/taxonomies/centenary_story_themes`)
                .then(({data}) => {
                    commit('SET_THEMES', {data, postType});
                    commit('FETCHING_THEMES', false);
                    return resolve();
                })
                .catch((error) => {
                    commit('FETCHING_THEMES', false);
                    return reject();
                });
        });
    },

    decades({commit}, postType) {
        commit('FETCHING_DECADES', true);
        return new Promise((resolve, reject) => {
            axios
                .get(`/api/taxonomies/centenary_story_decades`)
                .then(({data}) => {
                    commit('SET_DECADES', {data, postType});
                    commit('FETCHING_DECADES', false);
                    return resolve();
                })
                .catch((error) => {
                    commit('FETCHING_DECADES', false);
                    return reject();
                });
        });
    },

    positions({commit}, postType) {
        commit('FETCHING_POSITIONS', true);
        return new Promise((resolve, reject) => {
            axios
                .get(`/api/taxonomies/positions`)
                .then(({data}) => {
                    commit('SET_POSITIONS', {data, postType});
                    commit('FETCHING_POSITIONS', false);
                    return resolve();
                })
                .catch((error) => {
                    commit('FETCHING_POSITIONS', false);
                    return reject();
                });
        });
    },

    event_categories({commit}, postType) {
        commit('FETCHING_EVENT_CATEGORIES', true);
        return new Promise((resolve, reject) => {
            axios
                .get(`/api/taxonomies/event_categories`)
                .then(({data}) => {
                    console.log(data);
                    commit('SET_EVENT_CATEGORIES', {data, postType});
                    commit('FETCHING_EVENT_CATEGORIES', false);
                    return resolve();
                })
                .catch((error) => {
                    commit('FETCHING_EVENT_CATEGORIES', false);
                    return reject();
                });
        });
    },

    dates({commit}, postType) {
        commit('FETCHING_DATES', true);
        return new Promise((resolve, reject) => {
            let data = [
                {
                    'name': 'This week',
                    'slug': 'this-week'
                },
                {
                    'name': 'Next week',
                    'slug': 'next-week'
                },
                {
                    'name': 'July 2020',
                    'slug': 'july-2020'
                }
            ];
            commit('SET_DATES', {data, postType});
            commit('FETCHING_DATES', false);
            return resolve();
        });
    },
};

const mutations = {
    FETCHING_CATEGORIES(state, value) {
        state.fetching_categories = value;
    },
    SET_CATEGORIES(state, {data, postType}) {
        state[postType].categories = data;
    },

    FETCHING_THEMES(state, value) {
        state.fetching_themes = value;
    },
    SET_THEMES(state, {data, postType}) {
        state[postType].themes = data;
    },

    FETCHING_DECADES(state, value) {
        state.fetching_decades = value;
    },
    SET_DECADES(state, {data, postType}) {
        state[postType].decades = data;
    },

    FETCHING_APPEALS(state, value) {
        state.fetching_appeals = value;
    },
    SET_APPEALS(state, {data, postType}) {
        state[postType].appeal_tags = data;
    },

    FETCHING_JOBS(state, value) {
        state.fetching_jobs = value;
    },
    SET_JOBS(state, {data, postType}) {
        state[postType].job_types = data;
    },

    FETCHING_SUBJECTS(state, value) {
        state.fetching_subjects = value;
    },
    SET_SUBJECTS(state, {data, postType}) {
        state[postType].subjects = data;
    },

    FETCHING_POSITIONS(state, value) {
        state.fetching_positions = value;
    },
    SET_POSITIONS(state, {data, postType}) {
        state[postType].positions = data;
    },

    FETCHING_EVENT_CATEGORIES(state, value) {
        state.fetching_event_categories = value;
    },
    SET_EVENT_CATEGORIES(state, {data, postType}) {
        state[postType].event_categories = data;
    },

    FETCHING_DATES(state, value) {
        state.fetching_dates = value;
    },
    SET_DATES(state, {data, postType}) {
        state[postType].dates = data;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
